export default {
  siteName: 'Polaris',
  back: 'Back',
  logout: 'Log out',
  continue: 'Continue',
  update: 'Update',
  save: 'Save',
  cancel: 'Cancel',
  approve: 'Approve',
  close: 'Close',
  yes: 'Yes',
  no: 'No',
  in: 'in',
  and: 'and',
  male: 'Male',
  female: 'Female',
  days: {
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
  },
  months: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },
  validations: {
    required: 'Required field',
    email: 'Please enter a valid email address',
    hebrew: 'Please enter Hebrew letters only',
    characters: 'Please enter letters only',
    uid: 'Please enter a valid ID number',
    date: 'Please enter a valid date',
    number: 'Please enter digits only',
    mobile: 'Please enter a valid mobile phone number',
    phone: 'Please enter a valid phone number',
    autocomplete: 'Please select an item from the list',
  },
  buildingTypes: {
    building: 'Apartment building',
    house: 'Private house',
  },
};
